<div class="__chips">
  @for (chip of allChips(); track chip.projectId) {
    <zui-project-chip
      [projectName]="chip.projectName"
      [tags]="chip.tags"
      [roleCode]="chip.roleCode"
      [hasChanged]="chip.hasChanged"
      [menuActions]="chip.menuActions"
      (menuAction)="onMenuAction(chip.projectId, $event)"
    />
  }
</div>

@if (availableToAdd().length > 0) {
  <button
    mat-stroked-button
    type="button"
    class="__add-button  c-button--smaller"
    [class.has-chips]="allChips().length > 0"
    [disabled]="disabled() || isDisabled()"
    [satPopoverAnchor]="addAccessPopover"
    (click)="addAccessPopover.open()">
    <mat-icon>add</mat-icon>
    {{ addButtonText() }}
  </button>
}

<sat-popover
  #addAccessPopover
  [autoFocus]="false"
  [restoreFocus]="false"
  hasBackdrop
  [backdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClicked)="addAccessPopover.close()"
  (closed)="addAccessPopoverRef()?.reset()"
  [horizontalAlign]="'center'"
  [verticalAlign]="'below'">
  <zui-add-project-access-popover
    [projects]="availableToAdd()"
    [currentUser]="currentUser()"
    (projectsConfirmed)="onAddAccessConfirmed($event)"
    (cancelled)="addAccessPopover.close()"
  />
</sat-popover>
